import { createSelector } from 'reselect';

import { Features, core } from '@tock/coretypes';
import { StoreType } from '@tock/shared/utils/connect';
import { hasMinGlobalRoleHospitalitySelector } from 'selectors/rolesSelectors';
import { isPatronSiteBuilder } from '@tock/shared/utils/patron';

export const getFeatures = (state: StoreType) => state.features.features;

export const featuresSelector = createSelector(getFeatures, (features: Features) => features);

export const flexSelector = createSelector(
  (state: StoreType) => state.app.activeBusiness,
  (activeBusiness: core.Business) => {
    if (!activeBusiness) {
      return false;
    }

    return activeBusiness.inventoryMode === 'DEFAULT_TO_FLEX';
  }
);

/**
 * Access logic for menu creation and management functionality
 * MENU_UI - Enabled for all users of a business
 * MENU_UI_INTERNAL + role check - Enabled for internal Tock users
 */
export const hasMenusUISelector = createSelector(
  getFeatures,
  hasMinGlobalRoleHospitalitySelector,
  (state: StoreType) => state.app.patron,
  ({ MENU_UI, MENU_UI_INTERNAL }, isHospitalityOrAbove, patron) => {
    const isInternalMenusUser = isHospitalityOrAbove || isPatronSiteBuilder(patron);
    return !!(MENU_UI || (MENU_UI_INTERNAL && isInternalMenusUser));
  }
);

export const hasTaxCenterOrMigrationPeriodSelector = createSelector(
  featuresSelector,
  (features: Features) => !!features.TAX_CENTER_MIGRATION_PERIOD || !!features.TAX_CENTER
);

export const hasTaxCenterSelector = createSelector(
  featuresSelector,
  (features: Features) => !!features.TAX_CENTER
);
